import { render, staticRenderFns } from "./Finish.ts.vue?vue&type=template&id=98f3d2da"
import script from "./Finish.ts.vue?vue&type=script&lang=ts"
export * from "./Finish.ts.vue?vue&type=script&lang=ts"
import style0 from "./Finish.ts.vue?vue&type=style&index=0&id=98f3d2da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports